import { render, staticRenderFns } from "./EventForm2Component.vue?vue&type=template&id=9c055914&"
import script from "./EventForm2Component.vue?vue&type=script&lang=js&"
export * from "./EventForm2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports